exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-indicator[data-v-3576909e]{position:absolute;right:5px;bottom:5px;padding:1px 7px;color:#fff;font-size:12px;background:rgba(0,0,0,.3)}", ""]);

// exports
